import { render, staticRenderFns } from "./Zugangskarten.vue?vue&type=template&id=6b1c02ec&"
import script from "./Zugangskarten.vue?vue&type=script&lang=js&"
export * from "./Zugangskarten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports